import React from 'react';
import { inputStyles } from './shared/FormStyles';
import SizeControl from './shared/SizeControl';

const BusinessNameForm = ({ textElement, onElementChange }) => {
  return (
    <div className={inputStyles.container}>
      <div className="mb-6">
        <label className="block">
          <span className={inputStyles.label}>Business Name</span>
          <textarea
            rows={2}
            className={inputStyles.base}
            value={textElement.text}
            onChange={(e) => onElementChange('businessName', 'text', e.target.value)}
            placeholder="Enter your business name"
          />
        </label>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block">
            <span className={inputStyles.label}>Font Family</span>
            <select
              className={inputStyles.select}
              value={textElement.fontFamily}
              onChange={(e) => onElementChange('businessName', 'fontFamily', e.target.value)}
            >
              <option value="Roboto">Roboto</option>
              <option value="Lato">Lato</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Open Sans">Open Sans</option>
              <option value="Arial">Arial</option>
            </select>
          </label>
        </div>

        <div>
          <label className="block">
            <span className={inputStyles.label}>Font Style</span>
            <select
              className={inputStyles.select}
              value={textElement.fontStyle}
              onChange={(e) => onElementChange('businessName', 'fontStyle', e.target.value)}
            >
              <option value="normal">Normal</option>
              <option value="bold">Bold</option>
              <option value="italic">Italic</option>
              <option value="bold italic">Bold Italic</option>
            </select>
          </label>
        </div>
      </div>

      <div className="mt-4">
        <label className="block">
          <span className={inputStyles.label}>Text Color</span>
          <div className="mt-2 flex items-center gap-3">
            <input
              type="color"
              className={inputStyles.colorInput}
              value={textElement.color}
              onChange={(e) => onElementChange('businessName', 'color', e.target.value)}
            />
            <span className="text-sm text-gray-500">{textElement.color}</span>
          </div>
        </label>
      </div>

      <div className="mt-6">
        <SizeControl 
          element={textElement}
          onElementChange={onElementChange}
          elementKey="businessName"
        />
      </div>

    </div>
  );
};

export default BusinessNameForm;
